<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      icon="people"
    ></vuse-section-definition>

    <v-container fluid class="">
      <template>
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>
              {{ headTitle }}
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <div v-show="!isEdit">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon class="content-ma-0" v-on="on">
                    <v-icon small>mdi-cogs</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    @click="editItem()"
                    v-show="hasAccess('client.edit')"
                  >
                    <v-list-item-title>
                      <v-icon small left>mdi-pencil</v-icon>Edit
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="onDelete()"
                    v-show="hasAccess('client.delete')"
                  >
                    <v-list-item-title>
                      <v-icon small left>delete</v-icon>Delete
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <template v-slot:extension>
              <v-tabs v-model="tab" align-with-title>
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab> General</v-tab>
                <v-tab v-show="!isNew && hasAccess('task')"> Jobs </v-tab>
                <v-tab v-show="!isNew && hasAccess('quote')">
                  Bids
                </v-tab>
                <v-tab v-show="!isNew && hasAccess('timeClock')">
                  Time Clock
                </v-tab>
                <v-tab v-show="!isNew"> Notes </v-tab>
                <v-tab v-show="!isNew && hasAccess('vault')"> Password Vault </v-tab>
              </v-tabs>
            </template>
          </v-toolbar>
          <v-tabs-items v-model="tab">
            <v-tab-item v-show="hasAccess('client')">
              <ClientInfo ref="client" :clientId="clientId" :mode="mode" />
            </v-tab-item>
            <v-tab-item v-show="!isNew && hasAccess('task')">
              <TaskList ref="task" :clientId="clientId" :mode="mode" />
            </v-tab-item>
            <v-tab-item v-show="!isNew && hasAccess('quote')">
              <QuoteList ref="quote" :clientId="clientId" :mode="mode" />
            </v-tab-item>
            <v-tab-item v-show="!isNew && hasAccess('timeClock')">
              <TimeClock ref="timeclock" :clientId="clientId" :mode="mode" />
            </v-tab-item>
            <v-tab-item>
              <Notes ref="notes" :clientId="clientId" :mode="mode" />
            </v-tab-item>
            <v-tab-item v-show="!isNew && hasAccess('vault')">
              <PasswordVault ref="passwordVault" :clientId="clientId" :mode="mode" />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </template>
    </v-container>

    <delete-dialog
      :item="selectedItem"
      :show="showDelete"
      @onSucceded="afterDelete()"
      @onClosed="clearDelete()"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Notes from "./__Notes";
import ClientInfo from "./__ClientInfo";
import TaskList from "./__TaskList";
import TimeClock from "./__TimeClock";
import QuoteList from "./__QuoteList";
import PasswordVault from "./__PasswordVault";
import DeleteDialog from "./_Delete";
import formatterMixin from "@/mixins/formatterMixin";

export default {
  mixins: [formatterMixin],
  components: {
    Notes,
    ClientInfo,
    TaskList,
    QuoteList,
    DeleteDialog,
    TimeClock,
    PasswordVault
  },

  props: {
    mode: String,
  },

  data() {
    return {
      namespace: "Client Info",
      page: "Client Info",
      usage: "usage",
      tab: null,
      editMode: false,
      showDelete: false,
      selectedItem: {},
      form: {
        companyName: "",
        firstName: "",
        lastName: "",
      },
    };
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      client: (state) => state.client,
    }),

    clientId() {
      const { id } = this.$route.params;
      return parseInt(id);
    },

    isEdit() {
      return this.mode === "edit" && this.clientId ? true : false;
    },

    isNew() {
      return this.mode === "add" && !this.clientId ? true : false;
    },

    isView() {
      return this.mode === "view" && this.clientId ? true : false;
    },

    headTitle() {
      let companyTitle = this.client.single.isBusiness
        ? this.client.single.companyName
        : this.client.single.firstName + " " + this.client.single.lastName;
      if (this.isEdit) {
        return companyTitle + " (Edit)";
      } else if (this.isView) {
        return companyTitle;
      } else {
        return "Add New Client";
      }
    },

    tabActive() {
      return parseInt(this.optional(this.query, "tab", null));
    },

    query() {
      return this.$route.query;
    },
  },

  async mounted() {
    await this.loadData();
    if (this.tabActive !== null) {
      this.tab = this.tabActive;
    }
  },

  watch: {
    tabActive(n) {
      if (n !== null) {
        this.tab = n;
      }
    },
    async tab(n) {
      await this.refreshRef(n);
    },
  },
  methods: {
    ...mapActions("client", ["getById"]),
    ...mapActions({
      refreshClient: "client/getAll",
      refreshTask: "task/getAll",
      refreshQuote: "quote/getAll",
      refreshInvoice: "invoice/getAll",
      refreshTimeclock: "timeclock/getAll",
    }),

    async refreshRef(tab) {
      switch (tab) {
        case 0:
          // await this.refreshClient();
          break;
        case 1:
          break;
        case 2:
          // await this.refreshQuote();
          break;
        case 3:
          // await this.refreshInvoice();
          break;
        case 4:
          // await this.refreshTimeclock();
          break;
      }
    },
    async loadData() {
      if (this.isView || this.isEdit) {
        await this.getById(this.clientId);
      } else {
        console.log("its create");
      }
    },

    afterDelete() {
      this.$router.push(`/clients`);
    },

    editItem() {
      this.$router.push(`/clients/${this.$route.params.id}/edit`);
    },

    onDelete() {
      this.showDelete = true;
      this.selectedItem = this.client.single;
    },

    clearDelete() {
      this.showDelete = false;
      this.selectedItem = {};
    },
  },
};
</script>
